export default {
  tagList: null,
  engagementTypeId: -1,
  timezone: "",
  engagement: null,
  engagementParameters: null,
  tagArray: null,
  isRfmEnabled: null,
  customerCustomList: null,
  isDev: false,
  isLoading: true,
  countTotalCustomers: null,
  countAudienceCustomers: null,
  customAudienceCityList: null,
  customAudienceFirstNameList: null,
  customAudienceBrowserLangaugeList: null,
  customFieldsAudience: null,
  customAudienceCountryList: null,
  cancelToken: null,
};
